import React from 'react';
import { getSystemContact } from '../../AppShell/Authentication/AuthorisationAsync';
import { AllApplicationPermissions } from '../../Config/PermissionConfig';
import { getIdentityUser } from '../../Hooks/useIdentityLoader';
import { RobotWithCloudIcon } from '../Icons';
import styles from './ErrorAccessDenied.module.scss';

export interface IErrorAccessDeniedProps {
    requestedPermission?: AllApplicationPermissions | AllApplicationPermissions[];
}

export class ErrorAccessDenied extends React.Component<
    IErrorAccessDeniedProps,
    { username: string; name: string; page: string; systemContactEmail: string | null }
> {
    public state = { username: '', name: '', page: '', systemContactEmail: null };

    public componentDidMount() {
        const user = getIdentityUser();

        if (user != null) {
            this.setState({
                username: user.email,
                name: `${user.givenNames} ${user.familyName}`
            });
        }

        // eslint-disable-next-line no-restricted-globals
        this.setState({ page: location.pathname }, async () => {
            const systemContact = await getSystemContact();
            this.setState({ systemContactEmail: systemContact.email });
        });
    }

    public render() {
        const bodyTemplate = `A user of Communicare has requested additional permissions.
        Username: ${this.state.username}
        Full Name: ${this.state.name}
        Requested page: ${this.state.page}`;

        const body = encodeURIComponent(bodyTemplate);
        const email = `mailto:${this.state.systemContactEmail}?Subject=Permission%20request&body=${body}`;

        return (
            <div className={styles.container}>
                <RobotWithCloudIcon />
                <div className={styles.left}>
                    <div className={styles.text}>Whoops! You need additional permissions to view this page.</div>
                </div>
                {this.state.systemContactEmail && (
                    <a href={email} target='_top' className={styles.action}>
                        CONTACT ADMINISTRATOR
                    </a>
                )}
            </div>
        );
    }
}
